@if (sectionLoading) {
<div class="flex justify-center py-8 max-w-[2416px] px-4 md:px-[4.5rem] mx-auto">
  <app-loader [withBackground]="false" variant="secondary" [width]="150"></app-loader>
</div>
}
<ng-container *ngIf="allProperties$ | async; let model">
  <ng-container *transloco="let t; prefix: 'find-property.grid-list-cards'">
    <section class="relative mt-[-195px]">
      @if (!sectionLoading && model.count && model.count > 0) {
      <button
        class="sticky z-[1] top-[90vh] left-[50%] translate-x-[-50%] mb-[10rem] bg-[#003C49] text-white py-2 px-4 rounded-full flex items-center gap-2 transition duration-700 ease-in-out"
        [ngClass]="[
          isButtonVisible() ? 'opacity-100' : 'translate-y-[100px] opacity-0'
        ]" (click)="toggleDisplay()">
        <i [ngClass]="[displayMap ? 'icon-List' : 'icon-location']"></i>
        <span class="text-sm">Show {{ displayMap ? "list" : "map" }}</span>
      </button>
      } @if (criteriaAdjusted && model.count !== 0) {
      <div
        class="mt-4 border-t pt-4 flex flex-row gap-x-2 items-center min-h-[60px] text-base font-normal text-gray-700">
        <i class="icon-info-circle"></i>
        <span class="font-normal">{{ t("searchCriteriaAdjusted") }}</span>
      </div>
      }

      <div id="grid-container" [ngClass]="[
          displayMap
            ? 'flex lg:flex-row flex-col'
            : 'grid grid-cols-1 gap-6 mt-0'
        ]">
        <ng-container *ngIf="displayedProperties$ | async as properties">
          <div class="flex flex-col gap-6 relative justify-between p-8 pl-16" [ngClass]="{ 'lg:w-[43%]': displayMap }">
            <div class="flex justify-between items-center">
              <p>
                <span class="font-bold text-black">{{ modelCount }}</span>
                {{ t("propertiesResults") }}
              </p>
              <app-sort-dropdown [selectedKey]="selectedItem?.key" [dropdownItems]="orderByItems"
                (selectedItem)="orderByChanged($event)"></app-sort-dropdown>
            </div>
            <div #cardContainer class="grid grid-cols-1 gap-x-8 gap-y-6 relative flex-1"
              [ngClass]="{ 'lg:grid-cols-2 ': !displayMap }">
              <div id="top-anchor" class="absolute top-0 left-0 w-0 h-0 overflow-hidden"></div>
              <app-property-card-item *ngFor="let modelItem of properties; trackBy: trackByPropertyId"
                id="{{ modelItem.id }}" [attr.scroll-to]="modelItem.id" [attr.id]="modelItem.id"
                [propertySummary]="modelItem" class="hover: cursor-pointer md:max-h-[200px]"
                [focus]="modelItem.id === focusedCardId"></app-property-card-item>
              @if (loading) {
              <div class="w-full h-full absolute bg-white/80">
                <div class="h-[20%]">
                  <app-loader [withBackground]="false" variant="secondary" [width]="120"></app-loader>
                </div>
              </div>
              }
            </div>
            <div class="flex justify-center">
              <app-pagination [totalData]="modelCount" [pageSize]="pageSize" [currentPage]="currentPage" class="z-[10]"
                (pageSelect)="onPageSelect($event, true)">
              </app-pagination>
            </div>
          </div>
        </ng-container>
        <!-- h-[calc(100vh_-_390px)] xl:col-span-2 xl:h-[calc(100vh_-_355px)] overflow-hidden order-first lg:order-last relative lg:sticky-->
        <div id="map-container"
          class="h-[600px] lg:h-[80vh] right-0 lg:top-[188px] overflow-hidden order-first lg:order-last relative lg:sticky lg:w-[57%] w-full  mr-4 mt-4 rounded-lg"
          *ngIf="displayMap">
          <app-map [propertySummaries$]="googleMapItems.asObservable()"
            (scrollChanged)="mapViewChanged($event)"></app-map>
          <div
            class="hidden hover:cursor-pointer absolute top-0 left-0 translate-y-4 translate-x-4 transition-all hover:border-primary-900 drop-shadow-2xl bg-white border border-gray-300 rounded-full py-2 px-4">
            <label for="checkbox-selector-14" class="checkbox-selector secondary">
              <input type="checkbox" disabled class="hidden" id="checkbox-selector-14" name="checkbox-selector-"
                [checked]="mapSearch" />
              <div class="checkbox-selector-content">
                {{ t("mapSearchInfo") }}
              </div>
            </label>
          </div>
        </div>
      </div>
      <ng-container> </ng-container>
    </section>
  </ng-container>
</ng-container>